// import logo from "./logo.svg";
import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Layout from "./pages/Layout.jsx";
import Home from "./pages/Home.jsx";
import Panchanga from "./pages/Panchanga.jsx";
import Milan from "./pages/Milan.jsx";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/panchange" element={<Panchanga />} />
          <Route path="/milan" element={<Milan />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
